import axios from "axios";
import { USER_API } from "config";

const STORAGE_KEY = "rivetai_referral_code";

/**
 * Persist ?ref= or ?referral= from the current URL (call from signup/register routes).
 */
export function captureReferralCodeFromUrl(): void {
  if (typeof window === "undefined") {
    return;
  }
  const params = new URLSearchParams(window.location.search);
  const raw = params.get("ref") ?? params.get("referral");
  if (raw?.trim()) {
    window.localStorage.setItem(STORAGE_KEY, raw.trim().toLowerCase());
  }
}

/**
 * Ask the API to store the same code in an HttpOnly cookie (CORS credentials).
 * Call after capture when a code is present so email signup and OAuth initiate can read it server-side.
 */
export async function syncReferralCookieWithServer(code: string): Promise<void> {
  const c = code.trim().toLowerCase();
  if (!c) {
    return;
  }
  try {
    await axios.get(USER_API.referralsValidate(c), { withCredentials: true });
  } catch {
    // Banner still uses client-side validation; cookie is a best-effort duplicate of localStorage.
  }
}

export function getStoredReferralCode(): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  const v = window.localStorage.getItem(STORAGE_KEY);
  const t = v?.trim().toLowerCase();
  return t && t.length > 0 ? t : undefined;
}

export function clearStoredReferralCode(): void {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.removeItem(STORAGE_KEY);
}

const projectsBannerKey = (userId: string) =>
  `rivetai_referral_projects_banner_dismissed:${userId}`;

export function isReferralProjectsBannerDismissed(userId: string | undefined): boolean {
  if (typeof window === "undefined" || !userId) {
    return true;
  }
  return window.localStorage.getItem(projectsBannerKey(userId)) === "1";
}

export function dismissReferralProjectsBanner(userId: string): void {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(projectsBannerKey(userId), "1");
}
